<template>
  <div class="lp-create__media-post">
    <div class="lp-create__media-post__inner">
      <h2 class="lp-create__media-post__title lp-create__heading--main">
        おすすめの記事
      </h2>
      <BaseSlider
        :items="items"
        track-class="lp-create__media-post__track"
        slide-class="lp-create__media-post__slide"
      >
        <template #item="{ item }">
          <a
            class="lp-create__media-post__item"
            target="_blank"
            :href="item.link"
          >
            <div class="lp-create__media-post__item__thumb">
              <img
                class="lp-create__media-post__item__image"
                :src="item.url_image"
                :alt="item.slug"
                loading="lazy"
              >
            </div>
            <div>
              <h3 class="lp-create__media-post__item__title">
                {{ item.title }}
              </h3>

              <div class="lp-create__media-post__item__info">
                <span>{{ item.business }}</span>
                <span>{{ formatDate(item.date, 'YYYY.MM.DD') }}</span>
              </div>
            </div>
          </a>
        </template>
      </BaseSlider>
    </div>
  </div>
</template>

<script>
import BaseSlider from '@/components/frontend/Landing/BaseSlider';

export default {
  components: {
    BaseSlider
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
.lp-create__media-post {
  &__inner {
    width: 90%;
    max-width: 1180px;
    padding: 0;
    margin: 0 auto;
    display: block;
  }
  &__title {
    color: #222;
    margin-bottom: 24px;
  }
  &__content {
    background: #fff;
    padding: 32px 15px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (min-width: 768px), print {
      padding: 40px;
    }
  }
  &__slide {
    margin-bottom: 30px;
  }
  &__item {
    text-decoration: none;
    &:hover &__image {
      transform: scale(1.2);
      transition: 0.3s all ease;
    }
    &:hover &__title {
      color: #344897;
    }
    &__thumb {
      overflow: hidden;
    }
    &__image {
      width: 100%;
      height: 250px;
      object-fit: cover;
      transition: 0.3s all ease;
      @media screen and (max-width: 767px), print {
        height: 200px;
      }
    }
    &__title {
      font-size: 2rem;
      padding: 10px 0 5px;
      line-height: 1.4;
      color: #000;
      transition: color 0.3s ease;
    }
    &__info {
      color: #777;
      font-size: 1.4rem;
      > span {
        margin-right: 20px;
      }
    }
  }
  &::v-deep {
    .lp-create__media-post__slide {
      margin-bottom: 30px;
    }
  }
  @media screen and (min-width: 768px), print {
    &::v-deep {
      .lp-create__media-post__track {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin-bottom: 0;
        padding: 0 40px;
        flex: 1;
      }
    }
    &__item {
      box-shadow: none;
    }
  }
  @media screen and (min-width: 1024px), print {
    &::v-deep {
      .lp-create__media-post__track {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
  @media screen and (max-width: 767px), print {
    &__item {
      display: block;
      padding: 10px;
      border-radius: 10px;
      box-shadow: 0 3px 1px -3px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
      height: 100%;
    }
    &::v-deep {
      .lp-create__media-post__track {
        padding: 0;
      }
      .lp-create__media-post__slide {
        margin-bottom: 0;
      }
    }
  }
}
</style>
